<template>
  <v-alert
    border="left"
    text
    :type="type"
    icon="mdi-alert-circle"
    transition="scale-transition"
  >
    <h4 class="grow">
      {{ message }}
    </h4>
  </v-alert>
</template>

<script>
export default {
  name: "message-component",
  props: {
    message: { type: String },
    type: { type: String, default: "success" }
  }
};
</script>
